import { render } from "./AppButton.vue?vue&type=template&id=47b58cc2&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=47b58cc2&scoped=true&lang=css"

import exportComponent from "/Volumes/Work/1Gate/1Gate/1gate_check_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b58cc2"]])

export default __exports__